// extracted by mini-css-extract-plugin
module.exports = {"Container":"ProductList_Container__jPy5g","Title":"ProductList_Title__gNwfM","Bottom":"ProductList_Bottom___J8oa","Price":"ProductList_Price__xh_cS"};